class AfterPseudoElements {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
    }
    run() {
        window.addEventListener('resize', () => {
            this.update()
        })
        setTimeout(() => {
            this.update()
        }, 300)
    }
    update() {
        const items = document.querySelectorAll('.filter__item');
        let previousTop = null;

        items.forEach((item) => {
          // Remove the 'no-after' class from all items
          item.classList.remove('filter__item--no-after');
        });

        for (let i = 1; i < items.length; i++) {
          const currentTop = items[i].getBoundingClientRect().top;
          if (previousTop && previousTop !== currentTop) {
            // Add the 'no-after' class to the last item in the previous line
            items[i - 1].classList.add('filter__item--no-after');
          }
          previousTop = currentTop;
        }
    }
}

export default AfterPseudoElements